import { Step } from '@softline/application';
import { Lagerstamm } from './models/lagerstamm';

export const SOFTLINE_FEATURE_MDE_STOCK_POSTING = 'mdeStockPosting';

export const SOFTLINE_PERMISSION_MDE_STOCK_POSTING = 'STOCK_POSTING';

export const SOFTLINE_CONFIG_MDE_STOCKPOSTING_SELECT_STEPS: Step[] = [
  {
    header: 'Lager',
    subHeader: 'Lager auswählen',
    routerLink: ['/mde-stockposting/select-lager'],
  },
  {
    header: 'Lagersymbol',
    subHeader: 'Lagersymbol auswählen',
    routerLink: ['/mde-stockposting/stock-symbol'],
  },
  {
    header: 'Artikel',
    subHeader: 'Artikel hinzufügen',
    routerLink: ['/mde-stockposting/artikel-erfassen/search'],
  },
];

export function stockPostingSteps(selected: {
  lager?: string | null;
  symbol?: string | null;
  artikel?: string | null;
}): Step[] {
  const [lagerStep, symbolStep, artikelStep] =
    SOFTLINE_CONFIG_MDE_STOCKPOSTING_SELECT_STEPS;
  return [
    { ...lagerStep, subHeader: selected.lager || lagerStep.subHeader },
    { ...symbolStep, subHeader: selected.symbol || symbolStep.subHeader },
    { ...artikelStep, subHeader: selected.artikel || artikelStep.subHeader },
  ];
}

export function formatLager(lager: Lagerstamm | null | undefined): string | undefined {
  return lager ? `${lager.lager} · ${lager.name1}` : undefined;
}
